// extracted by mini-css-extract-plugin
module.exports = {"intl-account-button":"Button_intl-account-button__HNZUK"};